// app/javascript/channels/sheriff_report_channel.js

import consumer from "./consumer";

consumer.subscriptions.create(
  { channel: "SheriffReportChannel" },
  {
    initialized() {
      //console.log('SheriffReportChannel: inicializado');
    },
    connected() {
      //console.log('SheriffReportChannel: conectado');
    },
    disconnected() {
      //console.log('SheriffReportChannel: desconectado');
    },
    received({ company_id }) {
      $.ajax({
        type: "GET",
        url: `${window.location.origin}/companies/${company_id}/external_reports/sheriff_report_status`,
        dataType: "script",
      });

      if (
        window.location.pathname.includes("/external_reports/sheriff_report")
      ) {
        $.ajax({
          type: "GET",
          url: `${window.location.origin}/companies/${company_id}/external_reports/sheriff_report`,
          dataType: "script",
        });
      }
    },
  }
);
